import { H4, Text } from "components/Typography/text.styled";
import { InfoCircle } from "../../companyTipPayout/tips.styled";
import { useState } from "react";
import { FontFamily, FontSize } from "config/font";
import { Color } from "config/colors";
import {
  DividerLine,
  LocalStampClockContainer,
} from "../../companyStampClock/companyStampClock.styled";

export const SettingsSection: React.FC<{
  title: string;
  info?: string;
  children: React.ReactNode;
}> = ({ title, info, children }) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <LocalStampClockContainer>
        <H4>{title}</H4>
        {info && (
          <InfoCircle
            onMouseEnter={() => setShow(true)}
            onMouseLeave={() => setShow(false)}
          >
            <Text padding fontSize={FontSize.Small} color={Color.White}>
              i
            </Text>
          </InfoCircle>
        )}
      </LocalStampClockContainer>
      {info && show && (
        <Text
          fontSize={FontSize.Small}
          color={Color.SeaBlue600}
          fontFamily={FontFamily.MontserratSemiBold}
        >
          {info}
        </Text>
      )}
      {children}
      <DividerLine />
    </>
  );
};
